import { render, staticRenderFns } from "./SplitButton.vue?vue&type=template&id=565b4a90&scoped=true"
import script from "./SplitButton.vue?vue&type=script&lang=js"
export * from "./SplitButton.vue?vue&type=script&lang=js"
import style0 from "./SplitButton.vue?vue&type=style&index=0&id=565b4a90&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565b4a90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('565b4a90')) {
      api.createRecord('565b4a90', component.options)
    } else {
      api.reload('565b4a90', component.options)
    }
    module.hot.accept("./SplitButton.vue?vue&type=template&id=565b4a90&scoped=true", function () {
      api.rerender('565b4a90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SplitButton.vue"
export default component.exports